import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DockDashboard from "../dashboard/dock-dashboard";
import GateDashboard from "../dashboard/gate-dashboard";
import SignageDashboard from "../dashboard/config-dashboard";
// import TransporterPage from "../masters/transporter/transporterlist";
// import DockMasterPage from "../masters/vehicletype/vehiclelist";
import axios from "axios";
import {
  doc,
  onSnapshot,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "./firebase";
import { useLocation } from "react-router-dom";
import loaderGif from "../../assets/svg/loader.gif";
import invalidIcon from "../../assets/svg/invalid.svg";
import invalidDomainIcon from "../../assets/svg/invalid-domain.svg";
import notfoundIcon from "../../assets/svg/application-not-found.svg";
import linkNotFound from "../../assets/svg/link-not-found.svg";
import tokenExpire from "../../assets/svg/token-expired.svg";
import { useGlobal } from "../../GlobalContext";
import GateNewDashboard from "../dashboard/gateNew/gate-new-dashboard";
import DockWebDashboard from "../dashboard/dock-web/Default";
import VisitorDashboard from "../dashboard/gateNew/visitor-dashboard";

export default function SignageWidgets() {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const { dashboardToken, setDashboardToken } = useGlobal();
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalidId, setInvalidId] = useState(false);
  const [isInvalidDomain, setInvalidDomain] = useState(false);
  const [isInActive, setInActive] = useState(false);
  const [isInvalidToken, setInvalidToken] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [docId, setDocId] = useState(null);
  const [token, setToken] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data || typeof event.data !== "object") return;
      if (event.data.origin) {
        validateUrlConfig(id, event.data.origin);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    /*  axios.get('http://localhost:5000/api/hello')
      .then(res => {
        console.log(res.data.message)
      })
      .catch(err => console.error(err)); */
    //   try {
    //   axios.post('http://localhost:5000/api/data', {
    //     "domain": origin,
    //     "uuid": id
    //   });
    // } catch (error) {
    //   console.error('Error:', error);
    // }
  }, []);

  useEffect(() => {
    validateUrlConfig(id, "");
    /*  validateUrlConfigNodeJs(id,'') */
  }, [id]);
  /*  const validateUrlConfigNodeJs = async (id, origin) => {
try {
      const res = await axios.post('http://localhost:5000/api/validate', {
        "domain": origin,
        "uuid": id
      });
      console.log(res.data);
    } catch (error) {
      console.error('Error:', error);
    }
 } */
  const validateUrlConfig = async (id, origin) => {
    setIsLoading(true);
    const usersRef = collection(db, "signage-device");
    const q = query(usersRef, where("code", "==", id));

    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      const data = { id: doc.id, ...doc.data() };
      try {
        const response = await axios.post(
          `${apiUrl}validate_conf`,
          {
            domain: origin,
            uuid: id,
          },
          {
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: data.token,
            },
          }
        );

        if (response.data.success === true) {
          setIsLoading(false);
          setDashboardToken(data.token);
          setToken(data.token);
          setDocId(data.id);
          getSignageList(data.token ?? "");
        } else {
          setIsLoading(false);
        }
        return response; // ✅ make sure this line exists
      } catch (err) {
        if (err.response.status === 400) {
          if (err.response?.data.error?.uuid?.length > 0) {
            setInvalidId(true);
          }
          if (err.response?.data.error?.domain?.length > 0) {
            setInvalidDomain(true);
          }
        }
        if (err.response.status === 401) {
          setInvalidToken(true);
        }
        console.error(
          "Error saving customer:",
          err.response?.data || err.message
        );
        return err.response; // ✅ rethrow the error so the caller knows
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      setInvalidDomain(false);
      setInvalidId(true);
      console.log("No matching documents found");
    }
  };
  useEffect(() => {
    if (docId != null) {
      const unsub = onSnapshot(
        doc(db, "signage-device", docId),
        async (docSnapshot) => {
          if (docSnapshot.exists()) {
            //setUser(docSnapshot.data());
            const data = docSnapshot.data();

            if (data != null) {
              const isActivated = data.activate ?? false;
              if (isActivated === true) {
                setToken(data.token ?? "");
                const configStatus = data.configStatus ?? false;
                if (configStatus === true) {
                  getSignageList(data.token ?? "");
                  await updateDoc(doc(db, "signage-device", docId), {
                    configStatus: false,
                  });
                }
              } else {
                setInActive(true);
                // Navigator.pushNamed(context, '/welcome');
              }
            } else {
              setInActive(true);
              //Navigator.pushNamed(context, '/welcome');
            }
          } else {
            console.log("No such document!");
          }
        }
      );

      // Clean up listener on unmount
      return () => unsub();
    }
  }, [docId]);

  useEffect(() => {
    if (currentSlide != null && applicationList.length > 0) {
      const timeout = setTimeout(
        () => {
          const nextSlide = (currentSlide + 1) % applicationList.length;
          sliderRef.current?.slickGoTo(nextSlide);
        },
        applicationList.length > 0
          ? applicationList?.[currentSlide].duration_time * 1000 ?? 0
          : 0
      );

      return () => clearTimeout(timeout);
    }
  }, [currentSlide]);

  useEffect(() => {
    // //getSignageList()
    // setDocId("0PmUa1WHJKitPZKgCni9");
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    autoplay: false, // Manual autoplay
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "ease-in-out",
    afterChange: (index) => setCurrentSlide(index),
  };

  const getSignageList = async (token) => {
    try {
      const response = await axios.get(apiUrl + `get_signage_list`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          Authorization: token,
        },
      });
      if (response.data.success === true) {
        // eslint-disable-next-line array-callback-return
        /*  response.data.signageList?.map((application, i) => {
           const tempApp=[...applicationList];
           tempApp.
           setApplicationList(response.data.signageList);
         }) */
        setApplicationList(response.data.signageList);
        setCurrentSlide(0);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  return (
    <div>
      {isLoading === true && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={loaderGif}
            alt="Signage Icon"
            width={"131px"}
            height={"121px"}
          />
          <div
            style={{ fontSize: "28px", fontWeight: "700", color: "#1E1E1E" }}
          >
            Please wait a moment
          </div>
          <div
            style={{ fontSize: "16px", fontWeight: "400", color: "#9C9C9C" }}
          >
            Processing and analyzing your data...
          </div>
        </div>
      )}

      {isInvalidId === true && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={invalidIcon}
            alt="Invalid Icon"
            width={"64px"}
            height={"64px"}
          />
          <div
            style={{ fontSize: "28px", fontWeight: "700", color: "#1E1E1E" }}
          >
            Invalid ID
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
              color: "#9C9C9C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Check if there is a typo in{" "}
            <span
              style={{ fontSize: "16px", fontWeight: "500", color: "#1E1E1E" }}
            >
              {id}
            </span>
          </div>
        </div>
      )}

      {isInvalidDomain === true && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={invalidDomainIcon}
            alt="Invalid Icon"
            width={"64px"}
            height={"64px"}
          />
          <div
            style={{ fontSize: "28px", fontWeight: "700", color: "#1E1E1E" }}
          >
            Invalid Domain
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
              color: "#9C9C9C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <span style={{fontSize:'16px', fontWeight:'500',color:'#1E1E1E'}}>{id}</span> */}
          </div>
        </div>
      )}
      {isInvalidToken === true && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={tokenExpire}
            alt="Invalid Icon"
            width={"64px"}
            height={"64px"}
          />
          <div
            style={{ fontSize: "28px", fontWeight: "700", color: "#1E1E1E" }}
          >
            Token Expired !
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
              color: "#9C9C9C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span
              style={{ fontSize: "16px", fontWeight: "500", color: "#1E1E1E" }}
            >
              You can no longer use this token because it has expired.
            </span>
          </div>
        </div>
      )}
      {isInActive === true && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={notfoundIcon}
            alt="Invalid Icon"
            width={"64px"}
            height={"64px"}
          />
          <div
            style={{ fontSize: "28px", fontWeight: "700", color: "#1E1E1E" }}
          >
            Access Denied: This device is not currently active.
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
              color: "#9C9C9C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <span style={{fontSize:'16px', fontWeight:'500',color:'#1E1E1E'}}>{id}</span> */}
          </div>
        </div>
      )}

      {isLoading === false &&
        isInvalidId === false &&
        isInvalidToken === false &&
        isInActive === false && (
          <Slider ref={sliderRef} {...settings}>
            {applicationList?.map((application, i) => {
              if (application.type === "Internal") {
                if (application.application_name === "Gate Keeping - Signage") {
                  return (
                    <GateDashboard
                      interval={application.interval_time ?? 30}
                      widgets={application.internal_widgets ?? []}
                    />
                  );
                } else if (application.application_name === "Gate Keeping") {
                  return (
                    <GateNewDashboard
                      interval={application.interval_time ?? 30}
                      widgets={application.internal_widgets ?? []}
                    />
                  );
                } else if (application.application_name === "Dock - Signage") {
                  console.log("Dock application loaded....", i);
                  return (
                    <DockDashboard
                      interval={application.interval_time ?? 30}
                      widgets={application.internal_widgets ?? []}
                    />
                  );
                } else if (application.application_name === "Dock") {
                  console.log("Dock application loaded....", i);
                  return (
                    <DockWebDashboard
                      interval={application.interval_time ?? 30}
                      widgets={application.internal_widgets ?? []}
                    />
                  );
                } else if (
                  application.application_name === "Visitor Management"
                ) {
                  return (
                    <VisitorDashboard
                      interval={application.interval_time ?? 30}
                      widgets={application.internal_widgets ?? []}
                    />
                  );
                } else {
                  return (
                    <div
                      style={{
                        width: "100%",
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={notfoundIcon}
                        alt="Page Not Found"
                        width={"64px"}
                        height={"64px"}
                      />
                      <div
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#1E1E1E",
                        }}
                      >
                        Internal application not found !
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "#9C9C9C",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Needed internal application not available or not
                        founded.
                      </div>
                    </div>
                  );
                }
              } else if (application.type === "External") {
                if (
                  application.embedded_link != null &&
                  application.embedded_link !== ""
                ) {
                  return (
                    <div style={{ height: "calc(100vh - 120px)" }}>
                      <iframe
                        key={`iframekey${i}`}
                        title="User Profile iframe"
                        src={application.embedded_link}
                        style={{
                          width: "100%",
                          height: "calc(100vh - 120px)", // 100% of viewport height
                          border: "none",
                        }}
                      ></iframe>
                    </div>
                  );
                } else {
                  return (
                    <div
                      style={{
                        width: "100%",
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={linkNotFound}
                        alt="Page Not Found"
                        width={"64px"}
                        height={"64px"}
                      />
                      <div
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#1E1E1E",
                        }}
                      >
                        External link not found !
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "#9C9C9C",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        The provided link is not found. So go back and try
                        another one.
                      </div>
                    </div>
                  );
                }
              } else {
                return (
                  <div
                    style={{
                      width: "100%",
                      height: "100vh",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={linkNotFound}
                      alt="Page Not Found"
                      width={"64px"}
                      height={"64px"}
                    />
                    <div
                      style={{
                        fontSize: "28px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Application not found !
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#9C9C9C",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Needed application not available or not founded.
                    </div>
                  </div>
                );
              }
            })}
          </Slider>
        )}
    </div>
  );
}
